import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-detail',
  encapsulation:ViewEncapsulation.None,
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit {
  detail: any;
  commentCount: number=0;
  rootId: string;
  year=(new Date()).getFullYear();
  isBrowser: boolean=false;
  title: string;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.isBrowser=isPlatformBrowser(this.platformId);
    if (this.isBrowser||isPlatformServer(this.platformId)) {
      this.route.data.subscribe(data => {
        this.detail=data.analysisDetailResolver;
        this.commentCount=this.detail?.commentCount;
        this.title='Yorumlar '+(this.detail?.commentCount?'('+this.detail?.commentCount+')':'');
        this.rootId="analysis-"+this.detail?.url;
      })
    }
  }
  
  public trackByFnInfo(index, item) {
    if (!item) return null;
    return item.id;
  }  
 }
